<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vacation' }">休假管理</el-breadcrumb-item>
        <el-breadcrumb-item>休假申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ userArr.realname }} {{ userArr.en_name }} </h1>
        <p style="font-size: 20px; font-weight: 550;"></p>
        <p>{{ userArr.department?.en_name }} - {{ userArr.role?.role_name }}</p>
        <p>直属领导：{{ userArr.leader_name }} {{ userArr.leader_en_name }} </p>
      </div>
    </div>

    <div class="holiday">
      <div class="holi-head">
        <div class="info">休假说明<i class="el-icon-question" @click="infoShow = true"></i></div>
        <div class="time">
          <el-select v-model="year" placeholder="选择年份" @change="search(false)">
            <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
          </el-select>
        </div>        
      </div>
      <div class="holi-info">
        <div class="holi-son left">
          <div class="holi-li">
            <div class="holiday-box holi1">
              <div class="box-title">年假<div class="holiday-add" v-if="NodeInclude('377')" @click="showAddvacaFn('1')"><i
                    class="el-icon-circle-plus-outline"></i></div>
              </div>
              <!-- 年假 -->
              <div class="box-info">已休：{{ holidayArr?.annual_days }} / {{ holidayArr?.annual_total_days }}
              </div>
            </div>
          </div>
          <div class="holi-li">
            <div class="holiday-box holi5">
              <div class="box-title">调休<div class="holiday-add" v-if="NodeInclude('377')" @click="showAddvacaFn('4')"><i
                    class="el-icon-circle-plus-outline"></i></div>
              </div>
              <!-- 调休 -->
              <div class="box-info">已休：{{ holidayArr?.compensatory_days }} / {{
                holidayArr?.compensatory_total_days }}
              </div>
            </div>
          </div>
          <div class="holi-li">
            <div class="holiday-box holi2">
              <div class="box-title">婚假<div class="holiday-add" v-if="NodeInclude('377')" @click="showAddvacaFn('2')"><i
                    class="el-icon-circle-plus-outline"></i></div>
              </div>
              <!-- 婚假 -->
              <div class="box-info">已休：{{ holidayArr?.marriage_days }} / {{ holidayArr?.marriage_total_days }}
              </div>
            </div>
          </div>
          <div class="holi-li">
            <div class="holiday-box holi3">
              <div class="box-title"><template v-if="userArr.sex == '2'">产假</template><template v-else>陪产假</template>
                <div class="holiday-add" v-if="NodeInclude('377')" @click="showAddvacaFn('3')"><i
                    class="el-icon-circle-plus-outline"></i></div>
              </div>
              <!-- 产假/陪产假 -->
              <div class="box-info" v-if="userArr.sex == '2'">已休：{{ holidayArr?.maternity_days }} / {{
                holidayArr?.maternity_total_days }}</div>
              <div class="box-info" v-else>已休：{{ holidayArr?.paternity_days }} / {{
                holidayArr?.paternity_total_days }}
              </div>
            </div>
          </div>

        </div>
        <div class="holi-son right">
          <div class="holi-li">
            <div class="holiday-box holi6">
              <div class="box-title">事假</div>
              <!-- 事假 -->
              <div class="box-info">已休：{{ holidayArr?.personal_days }}</div>
            </div>
          </div>
          <div class="holi-li">
            <div class="holiday-box holi7">
              <div class="box-title">病假</div>
              <!-- 病假 -->
              <div class="box-info">已休：{{ holidayArr?.sick_days }}</div>
            </div>
          </div>
          <div class="holi-li">
            <div class="holiday-box holi8">
              <div class="box-title">丧假</div>
              <!-- 丧假 -->
              <div class="box-info">已休：{{ holidayArr?.bereavement_days }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="table">
      <div class="filterwrap">
        <div class="btnarea">
          <el-button @click="addVacaFn()" v-if="NodeInclude('384') && is_replace == '1'">代补假</el-button>
          <el-button @click="addVacaFn()" v-if="NodeInclude('381') && is_replace != '1'">新增休假</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="holiday_id" label="休假类型" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            {{ dd.holidayType[scope.row.holiday_id] }}
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="休假说明" header-align="center" align="center" min-width="250" />
        <el-table-column prop="holiday_tiem" label="休假起止时间" header-align="center" align="center" width="250">
          <template slot-scope="scope">
            {{ scope.row.start_date }}{{ scope.row.start_time == '1' ? '上午' : '下午' }} - {{ scope.row.end_date }}{{
              scope.row.end_time == '1' ? '上午' : '下午' }}
          </template>
        </el-table-column>
        <el-table-column prop="days" label="申请天数" header-align="center" align="center" width="120" />
        <el-table-column prop="status" label="申请状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.holidayStatus_c[scope.row.status].color }">
              <div class="word">{{ dd.holidayStatus_c[scope.row.status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="job_agency" label="职务代理人" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            <div class="job-agency" v-for="(item, index) in scope.row.job_agency_arr" :key="`ja_${index}`">
              <div class="job-agency-name">{{ item.agent_info?.realname }} {{ item.agent_info?.en_name }}</div>
              <div class="circle-tag" :style="{ 'background': dd.agent_check_status_c[item?.status].color }">
                <div class="word">{{ dd.agent_check_status_c[item?.status].word }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="主管审核状态" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <div class="circle-tag"
              :style="{ 'background': dd.leader_check_status_c[scope.row.leader_check_status].color }">
              <div class="word">{{ dd.leader_check_status_c[scope.row.leader_check_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="人事审核状态" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <div class="circle-tag"
              :style="{ 'background': dd.finance_check_status_c[scope.row.hr_check_status].color }">
              <div class="word">{{ dd.finance_check_status_c[scope.row.hr_check_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column prop="" label="操作" header-align="center" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleDelete(scope.row)"
                v-if="NodeInclude('382') && scope.row.bk_uid == userId">删除</el-link>
              <el-link type='primary' class="link" @click="handleClick(scope.row)"
                v-if="NodeInclude('381') && scope.row.bk_uid == userId">编辑</el-link>
              <el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('383')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 项目动态 -->
    <div class="history">
      <h3 class="ntitle">项目动态</h3>
      <el-form ref="trackForm" :model="trackForm" style="float:right;">
        <el-form-item label="" prop="track_event">
          <el-col :span="20">
            <el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
              @change="trackChange">
              <el-option label="全部流程" value="0"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <ul class="linehead">
        <li>时间</li>
        <li>操作人</li>
        <li>流程</li>
        <li>详情</li>
      </ul>
      <div class="timeline">
        <el-timeline>
          <el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList"
            :key="index" :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
            <div class="ico-edit">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <i class="el-icon-edit" @click="setTimeForm(item)"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="a" v-if="NodeInclude('391')">新增</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="NodeInclude('391')">编辑</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="NodeInclude('392')">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
              <!-- {{item}} -->
              <i class="point" v-if="item.point">+{{ item.point }}</i>
              <div v-if="!item.parent">
                <ul class="ul">
                  <li>
                    <span>{{ item.bkUserArr ? item.bkUserArr.realname : '暂无' }}</span>
                  </li>
                  <li>
                    <span>{{ item.eventName }}</span>
                  </li>
                  <li v-html="item.info"></li>
                </ul>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <el-dialog title="删除提醒" :visible.sync="delShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>您是否确定删除该条申请</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="休假说明" :visible.sync="infoShow" width="800px">
      <ul class="aul" style="padding:0">
        <li class="holi-body" v-for="(item, index) in holidayDetail" :key="`holi_${index}`">
          <div class="hold-head-title">{{ item.name }}说明</div>
          <div class="hold-head-content" v-for="(_it, _id) in item.description" :key="`holiday_${_id}`">{{ _it }}</div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增假期：" :visible.sync="addVacaShow" width="500px">
      <el-form ref="vacaForm" :model="vacaForm" label-width="150px" label-position="left">
        <el-form-item label="新增年假：" v-if="vacaForm.holiday_index == '1'">
          <el-col :span="8">
            <el-input placeholder="新增天数" maxlength="80" v-model="vacaForm.annual_total_days" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="新增婚假：" v-if="vacaForm.holiday_index == '2'">
          <el-col :span="8">
            <el-input placeholder="新增天数" maxlength="80" v-model="vacaForm.marriage_total_days" clearable />
          </el-col>
        </el-form-item>
        <template v-if="vacaForm.sex == '2' && vacaForm.holiday_index == '3'">
          <el-form-item label="新增产假：">
            <el-col :span="8">
              <el-input placeholder="新增天数" maxlength="80" v-model="vacaForm.maternity_total_days" clearable />
            </el-col>
          </el-form-item>
        </template>
        <template v-else-if="vacaForm.sex == '1' && vacaForm.holiday_index == '3'">
          <el-form-item label="新增陪产假：">
            <el-col :span="8">
              <el-input placeholder="新增天数" maxlength="80" v-model="vacaForm.paternity_total_days" clearable />
            </el-col>
          </el-form-item>
        </template>
        <el-form-item label="新增调休：" v-if="vacaForm.holiday_index == '4'">
          <el-col :span="8">
            <el-input placeholder="新增天数" maxlength="80" v-model="vacaForm.compensatory_total_days" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="关联客户：" prop="client_id" v-if="vacaForm.holiday_index == '4'">
          <el-col :span="24">
            <el-select v-model="vacaForm.client_id" placeholder="选择客户" style="margin-right: 0; width: 100%;" filterable
              @change="clientChange">
              <el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList"
                :key="`company_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="关联品牌：" prop="brand" v-if="vacaForm.holiday_index == '4'">
          <el-col :span="24">
            <el-select v-model="vacaForm.brand" placeholder="选择品牌" style="margin-right: 0; width: 100%;" filterable
              @change="brandChange">
              <el-option :label="v.brand" :value="v.brand" v-for="(v, i) in brandList" :key="`brand_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="关联项目：" prop="project_id" v-if="vacaForm.holiday_index == '4'">
          <el-col :span="24">
            <el-select v-model="vacaForm.project_id" placeholder="选择项目" style="margin-right: 0; width: 100%;" filterable
              @change="projectChange">
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in projectList" :key="`pro_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="supplement_desc">
          <el-col :span="24">
            <el-input v-model="vacaForm.supplement_desc" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容"></el-input>
          </el-col>
        </el-form-item>
        <div style="text-align: center;" v-if="vacaForm.holiday_index == '4'">注：关联项目后不能修改</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVacaShow = false">取 消</el-button>
        <el-button type="primary" @click="addVacationFn">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="timeForm.option == 1 ? '新增休假动态' : '编辑休假动态'" :visible.sync="trackShow" width="600px">
      <el-form ref="timeForm" :model="timeForm" label-width="140px" label-position="left" class="ulform">
        <el-form-item label="选择时间：" prop="create_time">
          <el-col :span="24">
            <el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间" style="width:100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择操作人：" prop="bk_uid">
          <el-col :span="24">
            <el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
              <el-option :label="`${v.en_name} ${v.realname}`" :value="v.id" v-for="(v, i) in userList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择流程：" prop="event_id">
          <el-col :span="24">
            <el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="休假申请" value="15"></el-option>
              <el-option label="休假审核" value="16"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="24">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="timeForm.info">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackShow = false">取 消</el-button>
        <el-button type="primary" @click="handleTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除休假动态" :visible.sync="delTrackShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>时间：</span>
          <span>{{ timeForm.create_time }}</span>
        </li>
        <li>
          <span>操作人：</span>
          <span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
        </li>
        <li>
          <span>项目状态：</span>
          <span>{{ dd.track_type[timeForm.event_id] }}</span>
        </li>
        <li>
          <span>详情：</span>
          <span v-html="timeForm.info"></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delTrackShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrack">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'vacationDetail',
  data() {
    return {
      uid: '',
      nodeLimtList: [],
      level: '',
      userId: '',
      mType: '5',
      userList: [],
      checkList: [
        '年份',
        '部门',
        '休假员工',
        '年假',
        '婚假',
        '产假',
        '陪产假',
        '调休',
        '事假',
        '病假',
        '丧假',
      ],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      vacaForm: {
        holiday_index: '',//用来记录是哪一个假期类型
        user_id: '',
        annual_total_days: '',
        marriage_total_days: '',
        maternity_total_days: '',
        paternity_total_days: '',
        compensatory_total_days: '',
        sex: '',
        client_id: '',
        brand: '',
        project_id: '',
        contract_no_name: '',
        supplement_desc: ''
      },
      DepartList: [],
      userArr: {},
      delShow: false,
      is_replace: '',
      tempDelId: '',
      infoShow: false,
      holidayArr: {},
      holidayDetail: {}, //说明
      addVacaShow: false,
      clientList: [],
      brandList: [],
      projectList: [],
      trackForm: {
        project_id: '',
        event_id: '',
      },
      delTrackShow: false,
      timeForm: {
        track_id: '',
        create_time: '',
        bk_uid: '',
        event_id: '',
        info: '',
        option: 1,
      },
      trackList: [],
      trackShow: false,
      currTrack: {//当前动态

      },
      year: '',
      yearList: [],
    }
  },
  computed: {
    parentActive() {
      return (item) => {
        return item.parent && item.active
      }
    },
    myTrackList() {
      return this.trackList.filter((item) => item)
    },
  },
  created() {
    this.uid = this.$route.query.uid
    this.uid && this.getYearList() 
    var date = new Date()
    this.year = (date.getFullYear()).toString()
    this.uid && this.getUserDetail(this.uid)
    this.uid && this.getList(this.uid)
    this.uid && this.trackChange()
  },
  mounted() {
    this.getClientList()
    this.geHolidayInfo()
    this.getUserList()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },

    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },

    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    link(url) {
      this.$router.push(url)
    },

    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },

    getYearList() {
      return new Promise((resolve) => {
        this.$fly.post('ApiHoliday_getYear.html', {
          user_id: this.uid
        })
        .then((res) => {
          this.yearList = res
          resolve(res)
        })
      })
    },

    async getClientList() {
      this.$fly.post('ApiAdministrative_brandDropdownList.html', {

      })
        .then((res) => {
          this.clientList = res
        })
    },

    async geHolidayInfo() {
      let postData = {

      }
      api.getHolidayInfo(postData).then((res) => {
        this.holidayDetail = res
      })
    },

    getBrandList(id) {
      this.$fly.post('ApiAdministrative_brandDropdownList.html', {
        client_id: id
      })
        .then((res) => {
          this.brandList = res
        })
    },


    getProjectList(client, brand) {
      this.$fly
        .post('ApiAdministrative_projectDropdownList.html', {
          client_id: client,
          brand: brand,
        })
        .then((res) => {
          this.projectList = res.length ? res : []
        })
    },

    search() {
      this.uid && this.getList(this.uid)
    },


    handleDelete(item) {
      if (this.is_replace == '1' && (item.holiday_id != '6' && item.holiday_id != '7' && item.holiday_id != '8') && this.level != '1') {
        this.$message.error('代补假只能删除事假、病假、丧假!')
        return false;
      }
      if (item.bk_uid != this.userId) {
        this.$message.error('代补假只能由发起人编辑!')
        return false;
      }
      if (!this.judgetMent(item)) {
        this.$message.error('该申请未提交、正在审核中或已完成！')
        return false;
      }
      this.delShow = true;
      this.tempDelId = item.id
    },

    handleDel() {
      this.$fly
        .post('ApiHoliday_applyHoliday.html', {
          del_str: this.tempDelId,
        })
        .then((res) => {
          this.$message.success(res.message)
          this.delShow = false;
          this.uid && this.getList(this.uid)
          this.uid && this.getUserDetail(this.uid)
          this.uid && this.trackChange()
        })
    },

    handleClick(item) {
      if (this.is_replace == '1' && (item.holiday_id != '6' && item.holiday_id != '7' && item.holiday_id != '8') && this.level != '1') {
        this.$message.error('代补假只能编辑事假、病假、丧假!')
        return false;
      }
      if (item.bk_uid != this.userId) {
        this.$message.error('代补假只能由发起人编辑!')
        return false;
      }
      if (!this.judgetMent(item)) {
        this.$message.error('该申请未提交、正在审核中或已完成！')
        return false;
      }
      this.$router.push({
        path: '/vacation/add',
        query: { id: item.id },
      })
    },

    handleView(item) {
      this.$router.push({
        path: '/vacation/view',
        query: { id: item.id },
      })
    },

    getUserDetail(id) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: id,
        })
        .then((res) => {
          this.userArr = res
        })
    },

    getList(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      api.getHolidayDetail({
        user_id: id,
        p: this.p,
        per_page: this.perPage,
        year: this.year,
      }).then((res) => {
        this.holidayArr = res.holiday
        this.itemList = res.itemList
        this.total = +res.totalNum
        this.getStoreFn()
      })
    },

    getStoreFn() {
      setTimeout(() => {
        //权限
        this.level = store.state.level
        this.userId = store.state.userId
        if (this.userId != this.uid) {
          this.is_replace = '1'
        }
        console.log(this.is_replace);
        
      }, 200);
    },

    handleCurrentChange(p) {
      this.p = p
      this.getList()
    },

    addVacaFn() {
      this.$router.push({
        path: '/vacation/add',
        query: { uid: this.uid },
      })
    },

    judgetMent(obj) {
      //approval_status申请了0就变1，代理人全同意变2，领导同意变3，财务同意变4，任意不同意变0
      if (obj.is_draft == '1') { //草稿
        return true //可编辑
      }
      else {
        if (obj.approval_status == '0') {
          return true //可编辑
        }
        else {
          return false //可编辑
        }
      }
    },

    showAddvacaFn(num) {
      this.vacaForm.user_id = this.uid
      this.vacaForm.sex = this.userArr.sex
      this.vacaForm.holiday_index = num
      this.addVacaShow = true
    },

    clientChange(v) {
      this.vacaForm.brand = ''
      this.vacaForm.project_id = ''
      this.vacaForm.contract_no_name = ''
      this.getBrandList(v)
    },

    brandChange(v) {
      this.vacaForm.brand = v
      this.vacaForm.project_id = ''
      this.vacaForm.contract_no_name = ''
      this.getProjectList(this.vacaForm.client_id, v)
    },

    projectChange(v) {
      this.$forceUpdate()
      for (let i = 0; i < this.projectList.length; i++) {
        let element = this.projectList[i];
        if (element.id == v) {
          this.vacaForm.contract_no_name = `${element.contract_no}-${element.contract_name}`
        }
      }
    },

    addVacationFn() {
      const temp = JSON.parse(JSON.stringify(this.vacaForm))
      let newTemp = {}
      if (temp.holiday_index == '1') {//年假
        const {
          user_id,
          annual_total_days,
          supplement_desc
        } = temp
        newTemp = {
          user_id,
          annual_total_days,
          supplement_desc
        }
      }
      if (temp.holiday_index == '2') {//婚假
        const {
          user_id,
          marriage_total_days,
          supplement_desc
        } = temp
        newTemp = {
          user_id,
          marriage_total_days,
          supplement_desc
        }
      }
      if (temp.holiday_index == '3') {//产假/陪产假
        if (temp.sex =='2') {
          const {
            user_id,
            maternity_total_days,
            supplement_desc
          } = temp
          newTemp = {
            user_id,
            maternity_total_days,
            supplement_desc
          }
        } 
        if (temp.sex =='1') {
          const {
            user_id,
            paternity_total_days,
            supplement_desc
          } = temp
          newTemp = {
            user_id,
            paternity_total_days,
            supplement_desc
          }
        }
      }
      if (temp.holiday_index == '4') {//婚假
        const {
          user_id,
          compensatory_total_days,
          client_id,
          brand,
          project_id,
          supplement_desc
        } = temp
        newTemp = {
          user_id,
          compensatory_total_days,
          client_id,
          brand,
          project_id,
          supplement_desc
        }
      }
      this.$fly
        .post('ApiHoliday_updateHoliday.html', {
          ...newTemp,
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
            this.uid && this.getList(this.uid)
            this.uid && this.trackChange()
          }
          this.addVacaShow = false
        })
    },
    compDate(item) {
      return item.smartTime + '' + item.weekTime
    },
    trigger(item) {
      let date = item.date || {}
      this.trackList = this.trackList.map((v) => {
        if (v.date === date) {
          v.active = !v.active
        }
        return v
      })
    },
    trackChange() {
      this.$fly
        .post('ApiHoliday_getTrackList', {
          project_id: this.query.uid,
          event_id: 17,
        })
        .then((res) => {
          this.trackList = res.trackList
        })
    },
    //修改项目动态
    setTimeForm(item) {
      console.log(item);
      const { bk_uid, create_time, event_id, id, info, bkUserArr } = item
      this.timeForm = {
        track_id: id,
        bk_uid,
        create_time,
        event_id,
        info,
        bkUserArr,
      }
    },
    handleCommand(command) {
      if (command == 'a') {
        this.timeForm = {
          track_id: '',
          bk_uid: '',
          create_time: '',
          event_id: '',
          info: '',
        }
        this.timeForm.option = 1
        this.timeForm.project_id = this.form.id
        this.trackShow = true
      }
      else if (command == 'b') {
        delete this.timeForm.bkUserArr
        this.timeForm.option = 2
        this.trackShow = true
      }
      else if (command == 'c') {
        console.log('c');
        this.delTrackShow = true
      }
    },
    handleTrack() {
      this.$fly
        .post('ApiStaffReimbursement_editTrackInfo.html', {
          ...this.timeForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.trackShow = false
          this.uid && this.trackChange()
        })
    },
    deleteTrack() {
      this.$fly
        .post('ApiStaffReimbursement_delTrack.html', {
          track_id: this.timeForm.track_id,
          mType: this.mType,
        })
        .then(() => {
          this.delTrackShow = false
          this.uid && this.trackChange()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.holiday {
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;

  .holi-head {
    font: 700 28px/1 $font;
    margin-bottom: 16px;
    @extend %start;
    align-items: center;
    .info {
      margin-right: 20px;
    }
  }

  .holi-info {
    @extend %start;

    .holi-son {
      @extend %start;
      flex-flow: row nowrap;
      justify-content: space-around;
      background: #ececec;
      padding: 20px 0;
      border-radius: 10px;

      &.left {
        width: 55%;
        margin-right: 20px;
      }

      &.right {
        width: calc(100% - 50% - 20px);
      }

      .holi-li {
        .holiday-box {
          @extend %center;
          width: 100px;
          height: 40px;
          padding: 10px;
          color: #fff;
          border-radius: 10px;

          &.holi1 {
            background: #02a7f0;
          }

          &.holi2 {
            background: #ec808d;
          }

          &.holi3 {
            background: #81d3f8;
          }

          &.holi4 {
            background: #81d3f8;
          }

          &.holi5 {
            background: #70b603;
          }

          &.holi6 {
            background: #f59a23;
          }

          &.holi7 {
            background: #8400ff;
          }

          &.holi8 {
            background: #333333;
          }

          .box-title {
            font: 600 18px/1 $font;
            margin-bottom: 5px;
            position: relative;

            .holiday-add {
              width: 18px;
              height: 18px;
              position: absolute;
              left: 110%;
              top: 0;
              cursor: pointer;
            }
          }

          .box-info {
            font: 400 14px/1 $font;
          }
        }
      }
    }
  }
}

.table {
  @extend %box;
  padding: 30px;
}

.expense {
  @extend %start;
  padding: 30px 0;

  >div {
    margin-right: 30px;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.description {
  @extend %start;

  div {
    &:nth-of-type(1) {
      width: 90px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 150px);
    }

    &:nth-of-type(3) {
      width: 60px;
    }
  }
}

.form-title {
  line-height: 40px;
}

.vaca-form {
  el-form-item {
    .el-form-item__content {
      el-col-8 {
        margin-right: 5px;
      }
    }
  }
}

.job-agency {
  @extend %start;
  padding: 0 20px;

  div {
    &.job-agency-name {
      width: 140px;
    }

    &.circle-tag {
      max-width: 80px;
      text-align: center;
    }
  }
}

.holi-body {
  text-align: left;

  .hold-head-title {
    padding: 10px 0;
    font: 600 20px/1 $font;
  }

  .hold-head-content {
    padding: 10px 0;

    div {
      font: 400 16px/1.5 $font;
    }
  }

}

.materialwrap {

  .history {
    @extend %box;
    padding: 30px 40px;
    margin-top: 30px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .bbtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }

        }
      }
    }
  }
}

</style>
<style lang="scss">
.linehead {
  //时间版头样式
  display: flex;
  flex-flow: row nowrap;
  font: 16px/1 $font;
  color: $c;
  padding: 25px 55px 0 60px;

  li {
    flex: auto;

    &:nth-child(1) {
      width: 190px;
      flex: none;
    }

    &:nth-child(2) {
      width: 190px;
      flex: none;
    }

    &:nth-child(3) {
      width: 190px;
      flex: none;
    }

    &:nth-child(4) {
      width: 880px;
      flex: none;
    }
  }
}

.timeline {
  //时间版内样式
  margin: 20px 25px 20px 30px;
  padding: 50px 30px;
  border-radius: 6px;
  border: solid 1px #bfbfbf;

  .ico-edit {
    display: block;
    width: 20px;
    height: 20px;
    z-index: 999 !important;
    position: absolute;
    left: -160px;
    top: 0px;
    cursor: pointer;

    ::before {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .mycard {
    min-height: 80px;
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 0 20px;
    position: relative;
    transform: translateY(-20px);
    // pointer-events: none;

    &.parent {
      pointer-events: auto;
      // cursor: pointer;
    }

    &.active {
      background-color: #fff;
      height: 30px;

      &:before {
        display: none;
      }

      dl,
      .point {
        display: none;
      }
    }

    &:before {
      content: '';
      font-size: 0;
      border-bottom: 20px solid #f5f5f5;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }

    dl {
      flex: none;
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      padding: 10px 60px 10px 00px;
      flex-flow: row nowrap;

      dd {
        height: 60px;
        width: 150px;

        &:nth-child(2) {
          width: 180px;
        }

        flex: none;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;

        span {
          font: 14px/30px $font;
        }
      }
    }

    .ul {
      padding: 0;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      z-index: 999;

      li {
        @extend %center;
        align-items: flex-start;
        min-height: 80px;
        flex: auto;
        font: 14px/20px $font;

        &:nth-child(1) {
          width: 180px;
          flex: none;
        }

        &:nth-child(2) {
          width: 180px;
          flex: none;
        }

        &:nth-child(3) {
          padding-left: 20px;
          display: flex;
          flex-flow: column nowrap;
          padding: 10px 60px 10px 20px;
          box-sizing: border-box;
          text-align: left;

          span {
            font: 14px/30px $font;

            &.grey {
              font-size: 14px;
              color: #999;
            }
          }

          a {
            display: inline-block;
            position: relative;
            z-index: 999999999999999999 !important;
            cursor: pointer;
          }
        }
      }
    }

    .point {
      position: absolute;
      background: $c;
      color: #fff;
      height: 30px;
      font: 16px/30px $font;
      padding: 0 10px;
      border-radius: 15px;
      right: 30px;
      top: 25px;
    }

    .ticon {
      position: absolute;
      left: -160px;
      height: 30px;
      line-height: 30px;
      padding: 0 20px 0 88px;
      color: #fff;
      top: 14px;
    }
  }

  .el-timeline {
    padding-left: 140px;

    .el-timeline-item {
      position: relative;
    }
  }

  .child {
    .el-timeline-item__timestamp.is-top {
      background-color: #ffffff;
      color: #9c9a9a;
      text-align: right;
    }
  }

  .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -140px;
    width: 120px;
    height: 30px;
    background-color: #2696d2;
    border-radius: 4px;
    color: #fff;
    font: 14px/30px $font;
    padding: 0 0 0 10px;
    top: -6px;
    box-sizing: border-box;
  }
}

.pdou {
  span {
    &::after {
      content: ',';
      display: inline-block;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }
}

.origin_name {
  @extend %start;

  >a {
    text-align: center;
  }
}

.inner {
  display: block;
  min-height: 23px;

  span {
    margin-right: 10px;
    font-size: 12px;
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

}

.linkbox {
  min-width: 32px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #DCDFE6;
  border-radius: 3px;
  padding: 4px 5px;
  cursor: pointer;
  border-color: #0E0F22;
  background: #0E0F22;
  color: #fff;

  &.grey {
    border-color: #c0c4cc;
    background: #c0c4cc;
    color: #fff !important;

    &:hover {
      background: #c0c4cc;
    }
  }

  &:hover {
    background: rgba($color: #0E0F22, $alpha: 0.8);
  }
}
</style>